// アメリカ大陸の世界史スポット。
// メソアメリカとアンデスの古代文明、スペイン植民地と価格革命、市民革命と移民、
// 帝国主義と太平洋戦争までを代表させる。
//
// 真珠湾は追悼施設のため ○×クイズを付けない。

export const AMERICAS_SITES = [
  {
    id: 'teotihuacan',
    name: 'テオティワカン 太陽のピラミッド',
    nameEn: 'Teotihuacan, Pyramid of the Sun',
    lat: 19.6925, lng: -98.8438, elevationM: 2280,
    region: 'americas', era: 'ancient',
    country: 'メキシコ（メキシコ州）',
    civilization: 'テオティワカン文明',
    yearLabel: '1〜6世紀に最盛',
    whcYear: 1987,
    emoji: '🔺',
    facts: [
      { label: '規模', value: '太陽のピラミッド 高さ 約65m' },
    ],
    summary:
      'メキシコ盆地に築かれた計画都市で、1〜6世紀の最盛期には人口10万を超えたとされる。「死者の大通り」を軸に太陽のピラミッドと月のピラミッドが配され、街区は格子状に整えられていた。黒曜石の加工と交易を握り、その文化はマヤ地域にまで及んでいる。7世紀頃に大規模な火災とともに衰退し、廃墟となった後にこの地へ来たアステカ人が「神々の都」を意味するテオティワカンと名づけた。建設者が誰であったのか、どの言語を話したのかは、いまも確定していない。',
    quiz: {
      statement: 'テオティワカンという名は、この都市を築いた人々が自ら名づけたものである。',
      answer: false,
      explain: 'テオティワカン（神々の都）は、廃墟となった後に来たアステカ人が付けた名です。建設者が何と呼んでいたかは分かっていません。',
    },
  },
  {
    id: 'chichen-itza',
    name: 'チチェン・イッツァ',
    nameEn: 'Chichén Itzá',
    lat: 20.6829, lng: -88.5686, elevationM: 30,
    region: 'americas', era: 'medieval',
    country: 'メキシコ（ユカタン州）',
    civilization: 'マヤ文明',
    yearLabel: '9〜13世紀に最盛',
    whcYear: 1988,
    emoji: '🔺',
    summary:
      'ユカタン半島に栄えたマヤの都市。中央に立つエル・カスティーヨ（ククルカンの神殿）は四面に91段の階段を持ち、合計364段に頂上の神殿を加えると365、すなわち1年の日数になる。春分と秋分の日には、階段の側面に羽毛の蛇が降りてくるような影が現れる。マヤは二十進法と「ゼロ」の概念を用い、精密な暦を作り、絵文字を発達させた。ただしユカタンの石灰岩台地には川がなく、水はセノーテと呼ばれる泉に頼っていた。この水こそ都市の立地を決めた要因である。',
    quiz: {
      statement: 'マヤ文明は「ゼロ」の概念を用い、精密な暦を作っていた。',
      answer: true,
      explain: 'マヤは二十進法とゼロを用い、太陽暦と儀礼暦を組み合わせた精密な暦法を発達させました。旧大陸とは独立にゼロに到達した数少ない例です。',
    },
  },
  {
    id: 'templo-mayor',
    name: 'テンプロ・マヨール（テノチティトラン）',
    nameEn: 'Templo Mayor, Tenochtitlan',
    lat: 19.4346, lng: -99.1315, elevationM: 2240,
    region: 'americas', era: 'medieval',
    country: 'メキシコ（メキシコシティ）',
    civilization: 'アステカ王国',
    yearLabel: '14〜16世紀 / 1521年 スペインが征服',
    whcYear: 1987,
    whcNote: '「メキシコシティ歴史地区とソチミルコ」の一部',
    emoji: '🔺',
    summary:
      'テスココ湖の島に築かれたアステカ王国の都テノチティトランの大神殿。湖上に浮かぶ人工島の耕地チナンパと、堤道で結ばれた計画都市には20万を超える人が暮らしていたとされる。1521年、コルテス率いるスペイン軍が、アステカに従属していた諸部族と手を結び、さらに旧大陸から持ち込まれた天然痘の流行に助けられてこれを征服した。神殿は破壊され、その石材でカテドラルが建てられた。現在の遺跡は、20世紀にメキシコシティの地下から掘り出されたものである。',
    quiz: {
      statement: 'スペインによるアステカ征服では、旧大陸から持ち込まれた感染症が大きな要因となった。',
      answer: true,
      explain: '免疫を持たない先住民の間で天然痘などが猛威をふるい、人口が激減しました。軍事的優位と現地諸部族の離反に加え、これが征服を決定づけました。',
    },
  },
  {
    id: 'nazca-lines',
    name: 'ナスカの地上絵',
    nameEn: 'Nazca Lines',
    lat: -14.7390, lng: -75.1300, elevationM: 500,
    region: 'americas', era: 'ancient',
    country: 'ペルー（イカ県）',
    civilization: 'ナスカ文化',
    yearLabel: '前2世紀〜後6世紀頃',
    whcYear: 1994,
    emoji: '🐦',
    summary:
      'ペルー南部の乾燥した台地に描かれた、ハチドリ・サル・クモなどの巨大な図形と直線群。表面の酸化した礫を取り除いて下の明るい地面を露出させる手法で、雨のほとんど降らない気候ゆえに二千年近く残った。全体像は上空からでないと捉えにくいが、地面に杭と縄で下絵を取れば描けることが実験で確かめられている。水源に関わる祭祀や、天体観測との関連が説かれてきたが定説はない。ヨーロッパとは無関係に発達したアンデス文明の、独自の世界観を今に伝える。',
    quiz: {
      statement: 'ナスカの地上絵は、地上での測量では描けないことが実験で確かめられている。',
      answer: false,
      explain: '杭と縄を使った相似拡大で描けることが実験で示されています。上空からしか全体を見にくいことと、地上から描けないことは別の話です。',
    },
  },
  {
    id: 'machu-picchu',
    name: 'マチュ・ピチュ',
    nameEn: 'Machu Picchu',
    lat: -13.1631, lng: -72.5450, elevationM: 2430,
    region: 'americas', era: 'medieval',
    country: 'ペルー（クスコ県）',
    civilization: 'インカ帝国',
    yearLabel: '15世紀半ば',
    whcYear: 1983,
    emoji: '⛰',
    facts: [
      { label: '標高', value: '約2,430m' },
    ],
    summary:
      'アンデスの尾根、標高約2430mに築かれたインカの都市遺跡。皇帝パチャクティの離宮とみる説が有力である。石材を刃物も通さぬほど精密に組み上げる技術、急斜面を階段状に拓いた段々畑、水路の設計はいずれも卓越している。インカは車輪も鉄器も文字も持たなかったが、キープと呼ばれる結び目の記録法と、総延長4万kmに及ぶ道路網で広大な領域を統治した。1533年にピサロによって帝国は滅ぼされたが、この都市は山中にあったため破壊を免れ、1911年に「再発見」された。',
    quiz: {
      statement: 'インカ帝国は文字を持たず、キープと呼ばれる結び目で数量などを記録した。',
      answer: true,
      explain: '色や結び目の形と位置で数量や情報を表すキープが使われました。車輪や鉄器も持たないまま、道路網と行政組織で広大な領域を統治しています。',
    },
  },
  {
    id: 'potosi',
    name: 'ポトシ銀山（セロ・リコ）',
    nameEn: 'Potosí, Cerro Rico',
    lat: -19.6167, lng: -65.7500, elevationM: 4050,
    region: 'americas', era: 'earlymodern',
    country: 'ボリビア（ポトシ県）',
    civilization: 'スペイン植民地／価格革命',
    yearLabel: '1545年 銀鉱発見',
    whcYear: 1987,
    emoji: '⛏',
    summary:
      '標高4000mを超えるアンデスの山で1545年に銀鉱が見つかり、17世紀初めには人口十数万の、当時としては世界有数の都市が生まれた。スペインはミタと呼ばれる先住民の強制労働で採掘を進め、無数の犠牲を出した。ここから流れ出た大量の銀はヨーロッパへ運ばれて物価を高騰させる価格革命を起こし、さらにアカプルコからマニラを経て中国へ渡り、明の税制を銀納へ転換させた（一条鞭法）。ひとつの鉱山が世界経済を結び直した、いわば「近世のグローバル化」の起点である。',
    quiz: {
      statement: 'アメリカ大陸から流入した大量の銀は、ヨーロッパで物価が高騰する価格革命を引き起こした。',
      answer: true,
      explain: '16世紀を通じて銀が流入し、ヨーロッパの物価は数倍に上昇しました。固定地代に頼る封建領主は打撃を受け、商工業者が力を伸ばします。',
    },
  },
  {
    id: 'independence-hall',
    name: 'インデペンデンス・ホール',
    nameEn: 'Independence Hall',
    lat: 39.9489, lng: -75.1500, elevationM: 10,
    region: 'americas', era: 'modern',
    country: 'アメリカ合衆国（フィラデルフィア）',
    civilization: 'アメリカ独立革命',
    yearLabel: '1776年 独立宣言 / 1787年 合衆国憲法',
    whcYear: 1979,
    emoji: '🔔',
    summary:
      '1776年7月4日に独立宣言が採択され、1787年には合衆国憲法が起草された建物。「代表なくして課税なし」を掲げた13植民地は、フランスの支援も得てイギリスからの独立を勝ち取った。ジェファソンが起草した独立宣言は、ロックの自然権思想を基礎に、生命・自由・幸福追求の権利と抵抗権を明記している。この理念はフランス革命や中南米の独立運動に波及した。一方で、宣言に署名した人々の多くが奴隷を所有していたという矛盾も、この建物は同時に抱えている。',
    quiz: {
      statement: '独立宣言に署名した人々は全員が奴隷制に反対しており、宣言と同時に奴隷制は廃止された。',
      answer: false,
      explain: '署名者の多くは奴隷所有者でした。奴隷制の廃止は南北戦争を経た1865年の憲法修正第13条まで待つことになります。理念と現実の落差はこの国の長い課題となりました。',
    },
  },
  {
    id: 'statue-of-liberty',
    name: '自由の女神像',
    nameEn: 'Statue of Liberty',
    lat: 40.6892, lng: -74.0445, elevationM: 5,
    region: 'americas', era: 'modern',
    country: 'アメリカ合衆国（ニューヨーク）',
    civilization: '移民の時代',
    yearLabel: '1886年 除幕',
    whcYear: 1984,
    emoji: '🗽',
    facts: [
      { label: '正式名称', value: '「世界を照らす自由」' },
      { label: '高さ', value: '台座を含め 約93m' },
    ],
    summary:
      '1886年、アメリカ独立100周年を記念してフランスから贈られた像。正式名称は「世界を照らす自由」という。彫刻家バルトルディが設計し、内部を支える鉄骨骨組みは、のちにエッフェル塔を建てるギュスターヴ・エッフェルが担当した。右手にたいまつを掲げ、左手には独立宣言の日付を刻んだ銘板を抱き、足元には引きちぎられた鎖が横たわる。19世紀末から20世紀初めにかけて大西洋を渡ってきた移民が最初に目にする光景となり、隣のエリス島とともに「移民の国」を象徴する存在となった。',
    quiz: {
      statement: '自由の女神像の内部を支える鉄骨構造は、のちにエッフェル塔を設計したエッフェルが手がけた。',
      answer: true,
      explain: '像の外側は薄い銅板で、それを支える鉄骨骨組みをエッフェルが設計しました。エッフェル塔の完成は1889年で、女神像の除幕はその3年前です。',
    },
  },
  {
    id: 'panama-canal',
    name: 'パナマ運河 ミラフローレス閘門',
    nameEn: 'Panama Canal, Miraflores Locks',
    lat: 8.9962, lng: -79.5910, elevationM: 15,
    region: 'americas', era: 'modern',
    country: 'パナマ（パナマ県）',
    civilization: '帝国主義',
    yearLabel: '1914年 開通',
    whcYear: null,
    emoji: '🚢',
    summary:
      '太平洋と大西洋を結ぶ全長約80kmの閘門式運河。スエズ運河を成功させたフランスのレセップスが挑んで黄熱病とマラリアに阻まれ、事業は破綻した。アメリカはパナマをコロンビアから独立させたうえで工事権を得て、1914年に開通させる。セオドア・ローズヴェルトの「棍棒外交」の代表例であり、アメリカがカリブ海を勢力圏とする転機となった。運河地帯は長くアメリカが管理したが、1977年の条約に基づき1999年末にパナマへ返還された。',
    quiz: {
      statement: 'パナマ運河の建設にあたり、アメリカはパナマをコロンビアから独立させたうえで工事権を得た。',
      answer: true,
      explain: '1903年、アメリカはパナマの独立運動を支援して承認し、直後に運河地帯の権利を得る条約を結びました。棍棒外交の典型とされます。',
    },
  },
  {
    id: 'pearl-harbor',
    name: '真珠湾 アリゾナ記念館',
    nameEn: 'Pearl Harbor, USS Arizona Memorial',
    lat: 21.3649, lng: -157.9500, elevationM: 0,
    region: 'americas', era: 'modern',
    country: 'アメリカ合衆国（ハワイ州）',
    civilization: '太平洋戦争',
    yearLabel: '1941年12月7日（現地時間）',
    whcYear: null,
    emoji: '⚓',
    summary:
      '1941年12月8日（ハワイ現地時間7日）、日本海軍がアメリカ太平洋艦隊の根拠地であるこの湾を攻撃した。戦艦アリゾナは弾薬庫の誘爆で沈没し、1100人を超える乗員が艦とともに海底に残された。この攻撃によりアメリカは第二次世界大戦に参戦し、ヨーロッパとアジアの戦争は文字どおり世界大戦となる。日米の国力差は開いており、その後の4年で戦線は日本本土へ及んだ。沈んだ艦を跨ぐように建てられた白い記念館の下には、今も船体が横たわっている。',
    // 追悼施設: クイズも「NEW!」バッジも出さない。
    solemn: true,
    quiz: null,
  },
  {
    // 出典: https://www.goldengate.org/bridge/history-research/moments-events/key-dates/
    // 出典: https://www.goldengate.org/bridge/history-research/bridge-construction/construction/
    sources: ['https://www.goldengate.org/bridge/history-research/moments-events/key-dates/', 'https://www.goldengate.org/bridge/history-research/bridge-construction/construction/'],
    id: 'golden-gate-bridge',
    name: 'ゴールデン・ゲート・ブリッジ', nameEn: 'Golden Gate Bridge',
    lat: 37.8199, lng: -122.4783, elevationM: 0,
    // 海面を標高基準にし、輪の下端を主塔より上に置く。
    ringAglM: 550,
    region: 'americas', era: 'modern',
    country: 'アメリカ（サンフランシスコ）', civilization: '20世紀の土木技術と交通',
    yearLabel: '1937年 開通',
    whcYear: null, emoji: '🌉',
    summary:
      'サンフランシスコ湾の入口にあたる海峡を渡る吊り橋で、1933年に着工し1937年に開通した。まず5月27日に歩行者へ開放され、翌日に自動車が通れるようになった。海峡の風や潮流などの条件に向き合いながら、主塔とケーブルによって長い橋桁を支える構造が実現された。橋は海を隔てた地域の移動を変え、都市と周辺地域の結び付きを強めた。名前の「ゴールデン・ゲート」は海峡の名で、橋が金色に塗られているという意味ではない。空から湾と外海、橋の位置を見比べると、なぜこの場所に大規模な交通施設が必要だったかを考えられる。港の砦や古代の街道と比べれば、時代ごとの技術が人の移動と都市の広がりを変えてきたことが分かる。',
    quiz: {
      statement: 'ゴールデン・ゲート・ブリッジは、ケーブルで橋桁を支える吊り橋である。',
      answer: true,
      explain: '主塔から渡したケーブルが橋桁を支えます。海峡を越える長い橋に、土木技術がどのように使われたかを観察できます。',
    },
  },
  {
    // 出典: https://www.aoc.gov/explore-capitol-campus/buildings-grounds/capitol-building/history
    sources: ['https://www.aoc.gov/explore-capitol-campus/buildings-grounds/capitol-building/history'],
    id: 'us-capitol',
    name: 'アメリカ合衆国議会議事堂', nameEn: 'United States Capitol',
    lat: 38.8899, lng: -77.0091, elevationM: 25,
    region: 'americas', era: 'modern',
    country: 'アメリカ（ワシントンD.C.）', civilization: 'アメリカ合衆国・共和政と連邦制',
    yearLabel: '1793年 定礎 / 1800年 議会が移転',
    whcYear: null, emoji: '🏛',
    summary:
      'アメリカ合衆国の連邦議会が置かれる建物で、1793年に礎石が据えられ、1800年に議会が移った。上院と下院の二つの議院が使う空間をもち、その後の増築によって現在につながる姿が整えられた。大きなドームや列柱には古典建築の様式が取り入れられ、新しい共和国が政治の理念を建築で表そうとしたことがうかがえる。ここは大統領の住居であるホワイトハウスとは別の施設で、立法と行政の役割の違いを考える手がかりになる。空から西へ延びるナショナル・モールや放射状の街路を見れば、首都が計画的に造られたことが分かる。ローマの建築やヨーロッパの宮殿と比較し、似た意匠が異なる政治体制で使われる点を観察できる。',
    quiz: {
      statement: 'アメリカ合衆国議会議事堂は、大統領が暮らすホワイトハウスと同じ建物である。',
      answer: false,
      explain: '議事堂は連邦議会の施設で、ホワイトハウスとは別です。立法を担う議会と、行政を担う大統領の役割も異なります。',
    },
  },
  {
    // 出典: https://whc.unesco.org/en/list/300/
    // 出典: https://mail.lacitadelle.qc.ca/fr/la-citadelle/son-histoire.html
    sources: ['https://whc.unesco.org/en/list/300/', 'https://mail.lacitadelle.qc.ca/fr/la-citadelle/son-histoire.html'],
    id: 'quebec-citadel',
    name: 'ケベックのシタデル', nameEn: 'Citadelle of Québec',
    lat: 46.8075, lng: -71.2075, elevationM: 95,
    region: 'americas', era: 'modern',
    country: 'カナダ（ケベックシティ）', civilization: 'フランス・イギリスの植民地史',
    yearLabel: '1820年 現在の要塞の建設開始',
    whcYear: 1985, whcNote: '「ケベック旧市街の歴史地区」の一部', emoji: '🏰',
    summary:
      'セントローレンス川を見下ろす高台にある要塞で、現在につながる施設は1820年からイギリス側によって建設された。ケベックは17世紀にフランス植民地の拠点として発達し、その後イギリスの支配へ移ったため、街には両方の時代の遺産が重なる。高台の上の町には行政や宗教の施設が置かれ、川沿いの下の町では港や商業が発展した。シタデルは城壁などとともに都市の防御を担い、地形と政治・軍事の関係を示している。上空から要塞の輪郭、崖、川の流れを見れば、航路を見渡せる立地の意味を理解しやすい。植民都市の発展を学ぶ際には、ヨーロッパ人の到来以前からこの地域に暮らした先住民の歴史も合わせて考えることが大切である。',
    quiz: {
      statement: 'ケベックの歴史地区には、フランスとイギリスの植民地時代の歴史が重なっている。',
      answer: true,
      explain: 'フランスの植民都市として発達した後、イギリスの支配へ移りました。要塞や町並みを複数の時代の積み重ねとして見られます。',
    },
  },
];
